//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _featureFlag from './featureFlag';
export const featureFlag = _featureFlag;
export default {featureFlag};

